import React from "react";

function InputTendinaCategoria(props) {
        
    const inputLabel=props.inputLabel;
    const datoName=props.datoName;
    const datoId=props.datoId;
    const datoOnChange= props.datoOnChange;
    const datoClass= props.datoClass;
    const objOpzioni = props.objOpzioni;
    const datoValue=props.datoValue;
    const datoDisabled = Boolean(props.datoDisabled);


    return (
        <div className="mb2">
            <label for={datoId}>{inputLabel}</label><br />                
               <select
                    name={datoName}
                    id={datoId}
                    className={datoClass}
                    onChange={datoOnChange}
                    value={datoValue}
                    disabled={datoDisabled}
                >      
                {
                    objOpzioni.length>0 && objOpzioni.map((dato,ind) => <option key={ind} value={dato.value} >{dato.label}</option>)
                }
                {
                    objOpzioni.length<=0 &&<option value="" disabled selected>Seleziona prima le categorie e salva</option>
                }                  
                </select> 
        </div>
    )
}

export default InputTendinaCategoria;
